import api from ".";
import type { PaginatedList } from "src/types/api";
import type { CollectionSettlementRow, OutstandingSettlementRow, PendingSettlementRow, SettlementSummary } from "src/types/settlement";

/** Query accepted by the settlement list endpoints. */
export interface SettlementQuery {
	page?: number;
	limit?: number;
	search?: string;
	from?: string;
	to?: string;
}

export const getPendingSettlements = (params?: SettlementQuery) =>
	api.get<PaginatedList<PendingSettlementRow>>("/settlements/pending-settlement", { params });

export const getCollectionSettlements = (params?: SettlementQuery) =>
	api.get<PaginatedList<CollectionSettlementRow>>("/settlements/collection-settlement", { params });

export const getOutstandingSettlements = (params?: SettlementQuery) =>
	api.get<PaginatedList<OutstandingSettlementRow>>("/settlements/outstanding-balance", { params });

export const getSettlementData = (params?: SettlementQuery) => api.get<SettlementSummary>("/settlements", { params });
